import {Navigate} from 'react-router-dom';
import {PRIVATE} from 'config/router/paths';
import {useAuthContext} from 'contexts/authContext';
import Dashboard from 'components/dashboard/admin/Dashboard';

export default function AdminRoute() {
  const {isAdmin} = useAuthContext();

  if (!isAdmin()) {
    return <Navigate to={PRIVATE} />;
  }

  return (
    <Dashboard/>
  );
}
